module.exports = __webpack_public_path__ + "img/RBIES-alt.92708551.svg";